export default "__VITE_ASSET__DiVrgo5c__"